import { render, staticRenderFns } from "./TicketComments.html?vue&type=template&id=bddca42e&scoped=true&external"
import script from "./TicketComments.vue?vue&type=script&lang=js"
export * from "./TicketComments.vue?vue&type=script&lang=js"
import style0 from "./TicketComments.scss?vue&type=style&index=0&id=bddca42e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddca42e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VAvatar,VBtn,VIcon,VTextarea,VTimeline,VTimelineItem})
